import type {
  ForwardRefExoticComponent,
  PropsWithChildren,
  RefAttributes,
} from 'react'
import { forwardRef } from 'react'

import { CardContent } from './components/CardContent'
import { CardFooter } from './components/CardFooter'
import { CardHeader } from './components/CardHeader'
import { CardMeta } from './components/CardMeta'
import { CardStyled, type ICardStyledProps } from './styles/CardStyled'

export interface ICardProps extends ICardStyledProps {}

export interface ICard extends ForwardRefExoticComponent<
  PropsWithChildren<ICardProps> & RefAttributes<HTMLDivElement>
> {
  Content: typeof CardContent
  Footer: typeof CardFooter
  Header: typeof CardHeader
  Meta: typeof CardMeta
}

export const Card = forwardRef<HTMLDivElement, PropsWithChildren<ICardProps>>(
  ({ children, ...props }, ref) => (
    <CardStyled {...props} ref={ref}>
      {children}
    </CardStyled>
  )
) as ICard

Card.Content = CardContent
Card.Footer = CardFooter
Card.Header = CardHeader
Card.Meta = CardMeta

Card.displayName = 'Card'
